import {
  GET_TOYS_FAIL,
  GET_TOYS_SUCCESS,
  GET_TOYS_GROUPED_SUCCESS,
  GET_TOYS_GROUPED_FAIL,
  ADD_TOY_SUCCESS,
  ADD_TOY_FAIL,
  UPDATE_TOY_SUCCESS,
  UPDATE_TOY_FAIL,
  DELETE_TOY_SUCCESS,
  DELETE_TOY_FAIL,
  UPDATE_TOY_AVAILABILITY,
  SET_LOADING
} from "./actionTypes";

import {
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
} from "../categories/actionTypes";

const INIT_STATE = {
  toys: [],
  totalPages: 0,
  toy: {},
  error: {},
  loading: true,
  addedToy: null,
  api: false
};

const Toys = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_TOYS_SUCCESS:
      return {
        ...state,
        toys: action.payload?.toys || [],
        totalPages: action.payload?.totalToys || 0,
        loading: false
      };

    case GET_TOYS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_TOYS_GROUPED_SUCCESS:
      return {
        ...state,
        toys: action.payload?.toys || [],
        totalPages: action.payload?.totalToys || 0,
        loading: false
      };

    case GET_TOYS_GROUPED_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case ADD_TOY_SUCCESS:
      return {
        ...state,
        // toys: [...state.toys, action.payload], // Don't append raw toy to grouped list
        addedToy: action.payload,
        loading: false
      };

    case ADD_TOY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case UPDATE_TOY_SUCCESS:
      return {
        ...state,
         toys: state.toys.map(toy =>
          (toy._id + '') === (action.payload._id + '')
            ? { ...toy, ...action.payload }
            : toy
        ),
        loading: false
      };

    case UPDATE_TOY_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case DELETE_TOY_SUCCESS:
      return {
        ...state,
        toys: state.toys.map(toy => {
          // If the group matches (this head toy was deleted)
          if (toy._id?.toString() === action.payload) {
            const updatedVariants = toy.variants?.filter(v => v._id?.toString() !== action.payload) || [];
            if (updatedVariants.length > 0) {
              // If there are other units, promote the first one to be the new head
              const newHead = updatedVariants[0];
              return {
                ...toy,
                ...newHead,
                variants: updatedVariants,
                variantCount: updatedVariants.length
              };
            }
            return null; // Group is empty
          }

          // Check if it's one of the variants in this group
          if (toy.variants?.some(v => v._id?.toString() === action.payload)) {
            const updatedVariants = toy.variants.filter(v => v._id?.toString() !== action.payload);
            return {
              ...toy,
              variants: updatedVariants,
              variantCount: updatedVariants.length
            };
          }
          return toy;
        }).filter(toy => toy !== null),
      };

    case DELETE_TOY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_TOY_AVAILABILITY:
      return {
        ...state,
        toys: state.toys.map((toy) =>
          toy._id === action.payload.toyId
            ? { ...toy, isAvailable: action.payload.isAvailable }
            : toy
        ),
      };

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
      };

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload || false,
      };

    default:
      return state;
  }
};

export default Toys;
